import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import websocketService from '../../services/websocketService';
import tabSessionService from '../../services/tabSessionService';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform);

const SessionClosedPage = () => {
  useEffect(() => {
    websocketService.setTabSessionBlocked(true);
    websocketService.disconnect();
    tabSessionService.destroy();

    const timer = window.setTimeout(() => {
      window.close();
    }, 100);

    return () => window.clearTimeout(timer);
  }, []);

  const handleTryClose = () => {
    window.close();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Session ended in this tab
        </h1>
        <p className="mt-3 text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
          Workloop is now active in another browser tab. This tab is no longer in use.
        </p>
        <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
          Close this tab with{' '}
          <kbd className="px-1.5 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-xs font-mono">
            {isMac ? '⌘' : 'Ctrl'}
          </kbd>
          {' + '}
          <kbd className="px-1.5 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-xs font-mono">
            W
          </kbd>
          , or use the button below.
        </p>
        <div className="mt-8 flex flex-col gap-2.5">
          <button
            type="button"
            onClick={handleTryClose}
            className="w-full px-4 py-2.5 rounded-xl bg-primary-600 text-white text-sm font-semibold hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
          >
            Close this tab
          </button>
          <Link
            to="/chat"
            className="w-full px-4 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 text-sm font-semibold hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
          >
            Open Workloop here instead
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SessionClosedPage;
